import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useHref, useLinkClickHandler, useLocation, useResolvedPath } from "react-router-dom";
import MuiLink from "@material-ui/core/Link";
import MuiButton from "@material-ui/core/Button";
import MuiMenuItem from "@material-ui/core/MenuItem";
import MuiListItem from "@material-ui/core/ListItem";
export function useLinkProps(props) {
    const { to, target, replace, state, onClick, ...rest } = props;
    let href = useHref(to ?? "");
    let internalOnClick = useLinkClickHandler(to ?? "", {
        replace,
        state,
        target
    });
    if (to == null)
        return { ...rest, target };
    function handleClick(event) {
        onClick?.(event);
        if (!event.defaultPrevented) {
            internalOnClick(event);
        }
    }
    return { ...rest, href, onClick: handleClick };
}
export function useIsActive(props) {
    const { to, caseSensitive = false, end = false } = props;
    const location = useLocation();
    const path = useResolvedPath(to ?? "");
    if (to == null)
        return false;
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    const isActive = locationPathname === toPathname ||
        (!end &&
            locationPathname.startsWith(toPathname) &&
            locationPathname.charAt(toPathname.length) === "/");
    return isActive;
}
export const RouterLink = forwardRef((props, ref) => (_jsx(MuiLink, { ref: ref, ...useLinkProps(props), underline: "hover" })));
export const RouterMenuItem = forwardRef((props, ref) => {
    return (_jsx(MuiMenuItem, { ...useLinkProps(props), ref: ref, component: "a", button: true, selected: useIsActive(props) }));
});
export const RouterListItem = forwardRef((props, ref) => {
    return (_jsx(MuiListItem, { ...useLinkProps(props), component: "a", ref: ref, button: true, selected: useIsActive(props) }));
});
export const RouterButton = forwardRef((props, ref) => {
    return _jsx(MuiButton, { ...useLinkProps(props), ref: ref, component: "a" });
});
//# sourceMappingURL=RouterLink.js.map